// extracted by mini-css-extract-plugin
module.exports = {"uploadWrapper":"TenantAutoInfoModal_uploadWrapper__11-D_","uploadButton":"TenantAutoInfoModal_uploadButton__jRCuZ"};